import { Permissions } from '@webapp/platform/iam'
import { useCheckPermission } from '../useCheckPermission'

export const useFinancialAccountPermissions = () => {
  const canManageFinancialAccount = useCheckPermission(
    Permissions.SETTINGS_MANAGE_FINANCIAL_ACCOUNT
  )

  return {
    canManageFinancialAccount,
  }
}
